<template>
  <v-window show-arrows class="my-4">
    <template v-slot:prev="{ on, attrs }">
      <v-btn v-bind="attrs" icon v-on="on" color="secondary">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </template>
    <template v-slot:next="{ on, attrs }">
      <v-btn v-bind="attrs" icon v-on="on" color="secondary">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </template>
    <!-- Affiche les card 3 par 3 si écran > xs -->
    <div v-if="display_small">
      <v-container v-if="news.length === 0">
        <v-row>
          <v-col v-for="i in 3" :key="i">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
      <v-window-item
        style="padding: 0 30px"
        v-for="n in nb_windows_desktop"
        :key="`card-${n}`"
        v-else
      >
        <v-item-group>
          <v-container>
            <v-row>
              <v-col v-for="i in 3" :key="i" cols="12" md="4" height="100%">
                <v-item v-slot="{ toggle }" height="100%">
                  <div @click="toggle" style="height: 100%">
                    <div v-if="display[n_item(n, i)]" style="height: 100%">
                      <news-cards-item
                        :newsItem="news[n_item(n, i)]"
                      ></news-cards-item>
                    </div>
                  </div>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-window-item>
    </div>
    <div v-else>
      <v-container v-if="news.length === 0">
        <v-row>
          <v-col>
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
      <v-window-item
        style="padding: 0 60px"
        v-for="n in nb_windows_small"
        :key="`card-${n}`"
      >
        <v-item-group>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-item v-slot="{ toggle }">
                  <div @click="toggle">
                    <div>
                      <news-cards-item :newsItem="news[n - 1]">
                      </news-cards-item>
                    </div>
                  </div>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-window-item>
    </div>
  </v-window>
</template>

<script>
import NewsCardsItem from "./NewsCardsItem.vue";

export default {
  data() {
    return {
      display: [],
    };
  },
  components: {
    NewsCardsItem,
  },
  props: {
    news: Array,
  },
  methods: {
    // méthodes pour afficher mes news par fenetre
    n_item(n, i) {
      let a = 0;
      if (n === 1) {
        a = n + i - 2;
      }
      if (n === 2) {
        a = n + i;
      }
      if (n === 3) {
        a = n + i + 2;
      }
      if (n === 4) {
        a = n + i + 4;
      }
      if (n === 5) {
        a = n + i + 6;
      }
      if (a >= this.news.length) {
        this.display[a] = false;
      } else {
        this.display[a] = true;
      }
      return a;
    },
  },
  computed: {
    // calcul le nombre de fenetre à afficher pour
    // avoir 3 news par fenetre
    nb_windows_desktop() {
      let news_length = this.news.length;
      let nb_windows_desktop = ~~(news_length / 3);
      if (news_length % 3 != 0) {
        nb_windows_desktop += 1;
      }
      if (nb_windows_desktop > 5) {
        nb_windows_desktop = 5;
      }
      return nb_windows_desktop;
    },
    display_small() {
      let display = true;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          display = false;
          break;
        case "sm":
          display = false;
          break;
        case "md":
          display = false;
          break;
        case "lg":
          display = true;
          break;
        case "xl":
          display = true;
          break;
      }
      return display;
    },
    nb_windows_small() {
      let nb_windows_small;
      if (this.news.length < 15) {
        nb_windows_small = this.news.length;
      } else {
        nb_windows_small = 15;
      }
      return nb_windows_small;
    },
  },
};
</script>